
























import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";
import router from "@/router";
import AppHeader from "@/components/AppHeader.vue";
import SideMenu from "@/components/SideMenu.vue";
import LoginView from "@/views/LoginView.vue";

@Component({
  components: { AppHeader, SideMenu, LoginView }
})
export default class App extends Vue {
  @namespace('auth').Getter('isLoggedIn') isLoggedIn!: any;
  title: string = "Overview";

  created() {
    this.$root.$on("SideMenuUpdate", (item: any) => {
      this.title = item.title;
    });
  }
}
